import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IPaginationResponse } from '../../../common';
import {
  IWalletResponse,
  IWalletTransactionResponse,
  IWalletIncomeResponse,
  IPaymentRequestChargeOrderDetailsResponse,
  IWalletTransactionsPaginationParameters,
  IWalletIncomesPaginationParameters,
  ILoadWalletOnlineRequest,
} from '../dtos';
import { IWalletsApiClient } from './i-wallets-api.client';
import { walletsData } from '../data';

@Injectable({
  providedIn: 'root'
})
export class WalletsInMemoryApiClient implements IWalletsApiClient {
  constructor(protected http: HttpClient) {}

  getMyWallet(): Observable<IWalletResponse> {
    return of(walletsData.walletResponse);
  }

  getMyWalletTransactions(params?: IWalletTransactionsPaginationParameters): Observable<IPaginationResponse<IWalletTransactionResponse>> {
    return of(walletsData.walletTransactionsResponse);
  }

  getMyWalletIncomes(params?: IWalletIncomesPaginationParameters): Observable<IPaginationResponse<IWalletIncomeResponse>> {
    return of(walletsData.walletIncomesResponse);
  }

  loadWalletOnline(request: ILoadWalletOnlineRequest): Observable<IPaymentRequestChargeOrderDetailsResponse> {
    return of(walletsData.loadWalletOnlineResponse);
  }
}
